import SubscriptionsAnalytics from '~/src/features/full-buy/analytics/Subscriptions.analytics';
import { actionTypes } from '~/src/features/full-buy/store';

export const selectSubscription = (subscriptionId: number, title: string, analytics: SubscriptionsAnalytics) => {
    analytics.clickSubscriptionsCheckBox(title);

    return {
        type: actionTypes.SelectSubscription,
        payload: {
            subscriptionId,
        },
    };
};
